import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelectionList } from '@angular/material/list';
import { ToastrService } from 'ngx-toastr';
import { SerialNumberStatus } from '../../../models/serial-number.model';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink2';
import * as XLSX from 'xlsx';

type AOA = any[][];
@Component({
  selector: 'app-util-serial-number-import-optional',
  templateUrl: './serial-number-import-optional.component.html',
  styleUrls: ['./serial-number-import-optional.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class SerialNumberImportOptionalComponent implements OnInit, OnDestroy {
  @Input() noDefaultValue : boolean;
  @Input() postingStatus;
  @Input() locationFieldColor$: Observable<string>;
  @Output() serialNumber = new EventEmitter<string[]>();
  protected subs = new SubSink();

  serialNumbers = [];
  form: FormGroup;
  @ViewChild(MatSelectionList, {static: true}) matList: MatSelectionList;
  byteSize = ['Bytes', 'KB', 'MB'];
  toUploadList: any[] = [];
  fileName;
  csv;
  fileExt;
  delimiter: string;
  newList: any[] = [];
  constructor(private toastr: ToastrService) { }

  ngOnInit() {
    this.form = new FormGroup({
      delimiter: new FormControl("", Validators.required),
    });
  }

  onDelimiterSelected(event) {
    this.delimiter = event;
    console.log(this.delimiter)
  }

  onChange(f: File) {
     if(f) {
      const reader = new FileReader();
      const file = f[0];
      this.fileName = file.name;
      if (!file.name.endsWith('.csv') && !file.name.endsWith('.xlsx')) {
        this.toastr.error("File type not supported", "Error", {
          tapToDismiss: true,

          progressBar: true,

          timeOut: 3000,
        });

      }
      else{
        console.log('file.name',file.name)
        if(file.name.endsWith('.csv')){
          this.fileExt = "csv";
          reader.readAsText(file);
        
          reader.onload = (e) => {
             this.csv = reader.result as string;
             
             
             
          }
        }else if(file.name.endsWith('.xlsx')){
          this.fileExt = "xlsx";
          this.form.patchValue({
            delimiter: "none",
          });
          reader.onload = (e:any) => {
             /* read workbook */
            const bstr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
            /* grab first sheet */
            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];
            this.toUploadList = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
            
          }
          reader.readAsBinaryString(file);
        }
       
      
      }

       
    }
  }

  onAdd() {
    console.log('this.csv',this.csv)
    if(this.csv && this.csv.length>0 && this.fileExt==="csv"){
      if(this.delimiter==='newline'){
        this.toUploadList = this.csv.match(/.+/g)
       }else{
        this.toUploadList = this.csv.split(this.delimiter)
       }

       this.toUploadList.map(s=>this.mapToSerialNumberObject(s));
    }
  
    if(this.fileExt==="xlsx"){
      console.log('add xlsx')
      this.toUploadList.map(s=>this.mapToSerialNumberObject(s[0]));
    }
    
    if(this.newList.length>0){
      this.serialNumber.emit(this.newList);
      this.newList = []
    }
    this.csv = []
  }

  mapToSerialNumberObject(sn: string){
    console.log('mapToSerialNumberObject',sn)
    if(sn!==undefined && sn!==null){
      const snObj = new SerialNumberStatus();
      snObj.sn_id = sn.toUpperCase().trim();
      snObj.status = "VALIDATION_IN_PROGRESS";
      
      this.newList.push(snObj);
    }
   }

  addToList(sn: string) {
    console.log(sn);
    //this.serialNumber.emit(sn.trim());
  }

  disableAdd(){
    let result = false;
    if(this.postingStatus==="FINAL"){
      result = true;
    }
    if(this.form.invalid){
      result = true;
    }
    return result;
  }

  onSelectAll() {
    this.matList.selectedOptions.selected.length === this.matList.options.length ? this.matList.deselectAll() : this.matList.selectAll();
  }

  onDeleteFile(file) {
    // this.store.dispatch(AttachmentActions.removeAttachment({id: file.id}))
  }

  onRemove() {
    this.serialNumbers = this.serialNumbers.filter(s => !this.matList._value.includes(s))
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}